document.addEventListener('DOMContentLoaded', function() {
   function removeActiveClass() {
        document.querySelectorAll("input.product-variant-id").forEach((el) => {
            el.classList.remove("active");
        });
    }
    removeActiveClass();
    document.querySelectorAll(".pack_bundle_deck .pack_bundle_boxButton").forEach((btn) => {
        btn.addEventListener("click", removeActiveClass);
    });
    function buttonPrice(){
        let getProce = document.querySelector('.pack_bundle_boxCol.active .price').innerHTML
        document.querySelector('.pack_bundle_boxButton button span').innerHTML = `&nbsp ${getProce}`
    }

    buttonPrice();

    document.querySelectorAll('.pack_bundle_boxCol').forEach(function(item) {
        item.addEventListener('click', function() {
            document.querySelectorAll('.pack_bundle_boxCol').forEach(function(el) {
                el.classList.remove('active');
            });

            this.classList.add('active');
            let printTotalHTML = this.dataset.pack;
            document.querySelector('.bundle_popupCount .count_total').innerText = printTotalHTML;

            buttonPrice();
        });
    });

    // Quantity + variant handling
    document.addEventListener("click", function(e){
        if(e.target.closest(".pack_bundle_boxCol")) {
            document.querySelectorAll('.pack_bundle_boxCol').forEach(function(el){
                el.classList.remove('active');
            });
            let clickedPack = e.target.closest(".pack_bundle_boxCol");
            clickedPack.classList.add('active');
            document.querySelectorAll(".bundle_proDuct_QtyRow input").forEach(function(inp){
                inp.value = 0;
            });
            document.querySelectorAll(".bundle_popupTrigger product-form input.product-variant-id").forEach(function(inp){
                inp.value = "";
            });
            document.querySelectorAll(".bundle_popupTrigger product-form input[name='quantity']").forEach(function(inp){
                inp.value = 0;
            });
            document.querySelectorAll('.bundle_proDuct_QtyRow .plus').forEach(btn => btn.disabled = false);
            let addBtn = document.querySelector('.bundle_popupBtn .addTo_trigger');
            if(addBtn) addBtn.disabled = true;
            let totalBox = document.querySelector('.bundle_popupCount .count_run');
            if(totalBox) totalBox.innerText = 0;
            return;
        }

        // Bundle popup button click → Full reset after 3s
        if(e.target.closest(".bundle_popupBtn button")){

            setTimeout(function(){

                console.log("Reset running after 3 seconds");
                document.querySelectorAll(".bundle_proDuct_QtyRow input[type='number']").forEach(function(inp){
                    inp.value = 0;
                });
                document.querySelectorAll(".bundle_popupTrigger product-form input[name='quantity']").forEach(function(inp){
                    inp.value = 0;
                });
                document.querySelectorAll(".bundle_popupTrigger product-form input.product-variant-id").forEach(function(inp){
                    inp.value = "";
                });
                document.querySelectorAll('.bundle_proDuct_QtyRow .plus').forEach(function(btn){
                    btn.disabled = false;
                });
                let addBtn = document.querySelector('.bundle_popupBtn .addTo_trigger');
                if(addBtn){
                    addBtn.disabled = true;
                }
                let totalBox = document.querySelector('.bundle_popupCount .count_run');
                if(totalBox){
                    totalBox.innerText = 0;
                }

            }, 3000);

            return;
        }

        // Quantity buttons logic
        if(e.target.closest(".bundle_proDuct_QtyRow button")){

            let btn = e.target;
            let qtyRow = btn.closest(".bundle_proDuct_QtyRow");
            let input = qtyRow.querySelector("input[type='number']");

            setTimeout(function(){
                let qtyValue = parseInt(input.value) || 0;
                let parentProduct = qtyRow.closest(".bundle_proDuct");
                let areaValue = parentProduct.getAttribute("data-area");
                let productForm = document.querySelector('.bundle_popupTrigger product-form[data-form="'+areaValue+'"]');

                if(productForm){
                    let formQtyInput = productForm.querySelector('input[name="quantity"]');
                    let variantInput = productForm.querySelector('input.product-variant-id');

                    if(qtyValue >= 1){
                        if(formQtyInput) formQtyInput.value = qtyValue;
                        if(variantInput) variantInput.value = qtyRow.getAttribute("data-id");
                        if(variantInput) variantInput.closest('.bundle_product_form').classList.add('active')
                    } else {
                        if(formQtyInput) formQtyInput.value = 0;
                        if(variantInput) variantInput.value = "";
                        if(variantInput) variantInput.closest('.bundle_product_form').classList.remove('active')
                    }
                }

                // Total Count
                let total = 0;
                document.querySelectorAll(".bundle_proDuct_QtyRow input").forEach(function(inp){
                    total += parseInt(inp.value) || 0;
                });

                let dataInputValue = document.querySelector('.pack_bundle_boxCol.active')?.dataset.pack || 0;
                console.log('Active Pack Limit:', dataInputValue);
                console.log("Total Quantity:", total);

                let totalBox = document.querySelector('.bundle_popupCount .count_run');
                if(totalBox) totalBox.innerText = total;

                if(total >= dataInputValue) {
                    document.querySelectorAll('.bundle_proDuct_QtyRow .plus').forEach(btn => btn.disabled = true);
                    let addBtn = document.querySelector('.bundle_popupBtn .addTo_trigger');
                    if(addBtn) addBtn.disabled = false;
                } else {
                    document.querySelectorAll('.bundle_proDuct_QtyRow .plus').forEach(btn => btn.disabled = false);
                    let addBtn = document.querySelector('.bundle_popupBtn .addTo_trigger');
                    if(addBtn) addBtn.disabled = true;
                }

            }, 50);
        }

    });


    let bundleInfo = document.querySelectorAll(".bundle_proDuctInfo");

    if (bundleInfo.length > 0) {
        bundleInfo.forEach(item => {
            item.addEventListener("click", function () {

                let parent = this.closest("[data-area]");
                if (parent) {

                    let areaValue = parent.getAttribute("data-area");
                    console.log("Area Value:", areaValue);

                    document.querySelector('.bundle_proInfo').classList.add('active');

                    let rows = document.querySelectorAll('.bundle_proInfo .bundle_proInfo_row');

                    rows.forEach(row => {
                        row.classList.remove('active');
                        let popupIndex = row.getAttribute("data-popupIndex");
                        console.log("Popup Index:", popupIndex);
                        if (areaValue == popupIndex) {
                            row.classList.add('active');
                        }
                    });
                }

                function adjustFaqDisplay() {
                    const isMobile = window.matchMedia("(min-width: 768px)").matches;

                    document.querySelectorAll('.question.open').forEach(item => {
                        item.classList.toggle('active', isMobile);
                    });

                    document.querySelectorAll('.reploCustom_faqContent.open').forEach(item => {
                        item.style.maxHeight = isMobile ? 'fit-content' : '';
                    });
                }
                setTimeout(adjustFaqDisplay, 200);
                window.addEventListener('resize', adjustFaqDisplay);

            });
        });
    }

}); 

// FAQ

let questions = document.querySelectorAll(".question");

questions.forEach(question => {
    question.addEventListener("click", () => {
        questions.forEach(item => {
            if (item !== question) {
                item.classList.remove("active");
                item.nextElementSibling.style.maxHeight = 0;
            }
        });

        // Current toggle karo
        question.classList.toggle("active");
        const answer = question.nextElementSibling;
        if (question.classList.contains("active")) {
            answer.style.maxHeight = answer.scrollHeight + "px";
        } else {
            answer.style.maxHeight = 0;
        }
    });
});